// const MAIN_API_URL = 'https://api.cashbackalert.net/api/';

export const performRequest = async (route, params = {}) => {
    return fetch(`${route}`, params)
        .then(response => response.json())
}